import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab2c5cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = {
  class: "D-Flex",
  style: {"width":"40%","flex":"auto"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = {
  class: "DialogSection",
  style: {"width":"60%","flex":"auto"}
}
const _hoisted_9 = { class: "DialogSectionTitle" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_14 = { class: "DialogSectionTitle" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_17 = { class: "DialogSectionTitle" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "Map"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_26 = { class: "DialogSectionTitle" }
const _hoisted_27 = {
  key: 1,
  class: "CookiesDialogFooter"
}
const _hoisted_28 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_map = _resolveComponent("l-map")!
  const _component_CookiesDateInput = _resolveComponent("CookiesDateInput")!
  const _component_NewPassword = _resolveComponent("NewPassword")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Employees_Edit': 'HR_Employees_Create'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: 'CookiesDialog_' + _ctx.DialogIndex,
          class: "CookiesDialogdBody"
        }, [
          (_ctx.Saving)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.Loading.length > 0)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CookiesImageInput, {
                    CookiesInvalidInput: _ctx.DefaultImageHandler(_ctx.MEMRead('D_Employee_Image')),
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Employee_Image') && _ctx.MEMRead('D_Employee_Image') === ''),
                    Res: 'D_Employee_Image',
                    Default: ''
                  }, null, 8, ["CookiesInvalidInput", "ErrorData"])
                ]),
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.Translate('Basic Info')), 1),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: _ctx.Translate('Name'),
                    CookiesInvalidInput: !_ctx.MEMRead('D_Employee_Name') && _ctx.MEMRead('D_Employee_Name') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Employee_Name') && _ctx.MEMRead('D_Employee_Name') === ''),
                    Res: 'D_Employee_Name',
                    Default: ''
                  }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: _ctx.Translate('Phone Number'),
                    CookiesInvalidInput: !_ctx.PhoneValidator(_ctx.MEMRead('D_Employee_PhoneNumber')),
                    ErrorData: _ctx.ErrorsVisibilty && !_ctx.PhoneValidator(_ctx.MEMRead('D_Employee_PhoneNumber')),
                    Res: 'D_Employee_PhoneNumber',
                    Default: ''
                  }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: _ctx.Translate('Email'),
                    CookiesInvalidInput: !_ctx.EmailValidator(_ctx.MEMRead('D_Employee_Email')),
                    ErrorData: _ctx.ErrorsVisibilty && !_ctx.EmailValidator(_ctx.MEMRead('D_Employee_Email')),
                    Res: 'D_Employee_Email',
                    Default: ''
                  }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Nationality'),
                    Default: '',
                    RowHeight: '3em',
                    Options: _ctx.Nationalities,
                    Selectors: ['Name'],
                    CookiesInvalidInput: !_ctx.MEMRead('D_Empolyee_Nationality') && _ctx.MEMRead('D_Empolyee_Nationality') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Empolyee_Nationality') && _ctx.MEMRead('D_Empolyee_Nationality') === ''),
                    Res: 'D_Empolyee_Nationality'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Gender'),
                    Radio: true,
                    Default: '',
                    RowHeight: '3em',
                    Options: [{Name: _ctx.Translate('Male')}, {Name: _ctx.Translate('Female')}],
                    Selectors: 'Name',
                    CookiesInvalidInput: !_ctx.MEMRead('D_Employee_Gender') && _ctx.MEMRead('D_Employee_Gender') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Employee_Gender') && _ctx.MEMRead('D_Employee_Gender') === ''),
                    Res: 'D_Employee_Gender'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _hoisted_10,
                  _hoisted_11,
                  _createVNode(_component_CookiesCheckBox, {
                    Res: 'D_Employee_IsDaily',
                    Name: _ctx.Translate('Daily Employee'),
                    PreserveMemory: false
                  }, null, 8, ["Name"]),
                  _hoisted_12,
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.Translate('Job Info')), 1),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Branch'),
                    Default: '',
                    RowHeight: '3em',
                    Options: _ctx.Branches,
                    Selectors: [['Name'], ['Branch', 'Name']],
                    CookiesInvalidInput: !_ctx.MEMRead('D_Empolyee_Branch') && _ctx.MEMRead('D_Empolyee_Branch') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Empolyee_Branch') && _ctx.MEMRead('D_Empolyee_Branch') === ''),
                    Res: 'D_Empolyee_Branch'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    onRemoved: _ctx.ResetPoisitonData,
                    onSelected: _ctx.PositionChanged,
                    Name: _ctx.Translate('Position'),
                    Default: '',
                    RowHeight: '3em',
                    Options: _ctx.Positions,
                    Selectors: [['Name'], ['Department', 'Name']],
                    CookiesInvalidInput: !_ctx.MEMRead('D_Empolyee_Position') && _ctx.MEMRead('D_Empolyee_Position') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Empolyee_Position') && _ctx.MEMRead('D_Empolyee_Position') === ''),
                    Res: 'D_Empolyee_Position'
                  }, null, 8, ["onRemoved", "onSelected", "Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Shift'),
                    Default: '',
                    RowHeight: '3em',
                    Options: _ctx.Shifts,
                    Selectors: ['Name'],
                    CookiesInvalidInput: !_ctx.MEMRead('D_Empolyee_Shift') && _ctx.MEMRead('D_Empolyee_Shift') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Empolyee_Shift') && _ctx.MEMRead('D_Empolyee_Shift') === ''),
                    Res: 'D_Empolyee_Shift'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Account Type'),
                    Radio: true,
                    Default: '',
                    RowHeight: '3em',
                    Options: [{Name: _ctx.Translate('Cash')}, {Name: _ctx.Translate('Bank')}, {Name: _ctx.Translate('E-Wallet')}],
                    Selectors: 'Name',
                    CookiesInvalidInput: !_ctx.MEMRead('D_Employee_AccountType') && _ctx.MEMRead('D_Employee_AccountType') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Employee_AccountType') && _ctx.MEMRead('D_Employee_AccountType') === ''),
                    Res: 'D_Employee_AccountType'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: _ctx.Translate('Account Number'),
                    Res: 'D_Employee_AccountNumber',
                    Default: ''
                  }, null, 8, ["Placeholder"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Work Place'),
                    Radio: true,
                    Default: '',
                    RowHeight: '3em',
                    Options: [{Name: _ctx.Translate('Branch Location')}, {Name: _ctx.Translate('Employee Location')}, {Name: _ctx.Translate('AnyWhere')}],
                    Selectors: 'Name',
                    CookiesInvalidInput: !_ctx.MEMRead('D_Employee_WorkPlace') && _ctx.MEMRead('D_Employee_WorkPlace') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Employee_WorkPlace') && _ctx.MEMRead('D_Employee_WorkPlace') === ''),
                    Res: 'D_Employee_WorkPlace'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.Translate('Legal Info')), 1),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: _ctx.Translate('Tax Number'),
                    Res: 'D_Employee_TaxNumber',
                    Default: ''
                  }, null, 8, ["Placeholder"]),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: _ctx.Translate('Passport Number'),
                    Res: 'D_Employee_PassportNumber',
                    Default: ''
                  }, null, 8, ["Placeholder"]),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: _ctx.Translate('Insurance Number'),
                    Res: 'D_Employee_InsuranceNumber',
                    Default: ''
                  }, null, 8, ["Placeholder"]),
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: _ctx.Translate('National Number'),
                    Res: 'D_Employee_NationalNumber',
                    Default: ''
                  }, null, 8, ["Placeholder"]),
                  _hoisted_18,
                  (_ctx.MEMRead('D_Employee_WorkPlace') === 'User Location')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_l_map, {
                          ref: "map",
                          zoom: _ctx.zoom,
                          center: _ctx.markerLatLng ? _ctx.markerLatLng : [31.9522, 35.9375],
                          onClick: _ctx.handleMapClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_l_tile_layer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
                            (_ctx.CheckmarkerLatLng)
                              ? (_openBlock(), _createBlock(_component_l_marker, {
                                  key: 0,
                                  "lat-lng": _ctx.CheckmarkerLatLng
                                }, null, 8, ["lat-lng"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["zoom", "center", "onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_20,
                  _hoisted_21,
                  _createVNode(_component_CookiesDateInput, {
                    Name: _ctx.Translate('Hire Date'),
                    Type: 'date',
                    Res: 'D_Employee_HireDate'
                  }, null, 8, ["Name"]),
                  _createVNode(_component_CookiesDateInput, {
                    Name: _ctx.Translate('Birth Date'),
                    Type: 'date',
                    Res: 'D_Employee_BirthDate'
                  }, null, 8, ["Name"])
                ])
              ]),
              _hoisted_22,
              _hoisted_23,
              _createVNode(_component_CookiesCheckBox, {
                Res: 'D_Employee_CanLogin',
                Name: _ctx.Translate('Can Login'),
                PreserveMemory: false
              }, null, 8, ["Name"]),
              _createElementVNode("div", {
                class: _normalizeClass([!_ctx.MEMRead('D_Employee_CanLogin') && 'Disabled', "DialogSection"])
              }, [
                _createVNode(_component_NewPassword, {
                  Editing: _ctx.DialogData.Editing,
                  Disabled: !_ctx.MEMRead('D_Employee_CanLogin'),
                  onChangePassword: _ctx.ChangePassword,
                  ErrorsVisibilty: _ctx.ErrorsVisibilty &&!_ctx.PasswordValidator(_ctx.MEMRead('D_Employee_Password')),
                  Res: 'D_Employee_Password'
                }, null, 8, ["Editing", "Disabled", "onChangePassword", "ErrorsVisibilty"])
              ], 2),
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.Translate('Benifits')), 1),
              _createVNode(_component_CookiesTable, {
                class: "Shadow1",
                TableSettings: _ctx.TableSettings,
                CookiesData: _ctx.CookiesData,
                Search: '',
                Loading: (_ctx.Loading.length > 0),
                SavingTable: (_ctx.SavingTable.length > 0),
                Saved: _ctx.Saved
              }, null, 8, ["TableSettings", "CookiesData", "Loading", "SavingTable", "Saved"])
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Employees_Edit': 'HR_Employees_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              class: "F-Bold CookiesButton DialogFooterButton BGMain"
            }, _toDisplayString(_ctx.Translate('Save')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}